<template>
  <a-modal
    ref="createModal"
    title="参数选择"
    :width="400"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirmValidate"
    :confirmLoading="confirmLoading"
  >
    <a-form-model layout="horizontal" :model="queryParams" ref="ruleForm" :rules="rules" :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }">
      <a-row>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="计划展望期（M+）" prop="planningHorizonDays">
            <a-input-number :min="0" :max="12" v-model="queryParams.planningHorizonDays" class="width100"/>
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="产品属性" prop="itemAttribute">
            <global-select
              :setParams="{lookupType:'SCP_ITEM_ATTRIBUTE'}"
              :value.sync="queryParams.itemAttribute"
              selectType="selectFilter"
              requestApi="/system/lookup/data/list"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="包含值" prop="includeValues">
            <global-select
              :setParams="{category: queryParams.itemAttribute}"
              :value.sync="queryParams.includeValues"
              selectType="selectMultiple"
              requestApi="/scp/scpSopMpsOptions/listIncluding"
              :selectItem="{ value: 'realValue', label: 'label' }"
              searchParam="version"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="一件代发" prop="singleShipment">
            <a-select option-filter-prop="children" v-model="queryParams.singleShipment" >
              <a-select-option v-for="(item) in isRetailFlags" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { apiAddMpsFdOptions } from '@/api/finished-goods-order'
// 表单字段
export default {
  name: 'CreateModal',
  props: {},
  data () {
    return {
      visible: false,
      // 当前控件配置:
      confirmLoading: false,
      // 是否一件代发
      isRetailFlags: [
        {
          dictLabel: "全部",
          dictValue: "A"
        },
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      queryParams: {
        planningHorizonDays: undefined,
        singleShipment: undefined,
        includeValues: undefined, // 包含值
        itemAttribute: undefined // 产品属性
      },
      rules: {
        planningHorizonDays: [{ required: true, message: '计划展望期不能为空', trigger: 'change' }],
        singleShipment: [{ required: true, message: '一件代发不能为空', trigger: 'change' }],
        includeValues: [{ required: true, message: '包含值不能为空', trigger: 'change' }],
        itemAttribute: [{ required: true, message: '产品属性不能为空', trigger: 'change' }]
      }
    }
  },
  created () {},
  methods: {
    show (val) {
      this.visible = true
      this.queryParams = {};
      if(val && val.id) {
        this.queryParams.id = val.id
      }
      if(val && val.planningHorizonDays) {
        this.queryParams.planningHorizonDays = val.planningHorizonDays
      }
      if(val && val.singleShipment) {
        this.queryParams.singleShipment = val.singleShipment
      }
      if(val && val.includeValues) {
        this.queryParams.includeValues = val.includeValues
      }
      if(val && val.itemAttributeName) {
        this.queryParams.itemAttribute = val.itemAttribute
      }
    },
    // 关闭模态框
    close () {
      this.queryParams = {};
      this.visible = false
      // 调用外部刷新列表方法
      this.$emit('handle-success')
    },
    /**
     * 保存版本
     * @param record
     * @param dataIndex
     */
    confirmValidate (record) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = {
            ...this.queryParams
          }
          apiAddMpsFdOptions(params).then(response => {
            if (response.code === 200) {
              this.$message.success('保存成功')
              this.$emit('finish')
            } else {
              this.$message.error(response.msg)
            }
            this.visible = false
          }).catch(e => {
            this.$message.error(e.msg)
            this.visible = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
input {
  width: 150px;
}
/deep/.width100{
  width: 100%;
}
/deep/.ant-modal-body {
  height: 320px !important;
  overflow-y: scroll;
}
.table-title {
  font-weight: bold;
  padding: 5px 0;
}
</style>
